import {
  ConfigurationSearchFormQuery,
  HotelBenefitListQuery,
} from "@/types/generated";
import { HotelBrandItemNullable } from "@app/[locale]/brands/[brand_slug]/page";

export const handleBenefitListData = (benefitList?: HotelBenefitListQuery) => {
  const benefitsListData = benefitList?.contents[0]?.amenities_and_services
    ?.hotel_benefits
    ? benefitList.contents[0]?.amenities_and_services?.hotel_benefits
        ?.map((item) => {
          if (item?.documentId && item?.item_name) {
            return {
              value: item?.documentId,
              label: item?.title || "",
            };
          } else {
            return null;
          }
        })
        .filter((benefit) => benefit !== null)
    : [];
  return benefitsListData;
};

export const handleBrandListData = (brandList?: HotelBrandItemNullable[]) => {
  const brandListData = brandList
    ? brandList
        ?.map((item) => {
          if (item?.documentId && item?.title) {
            return {
              value: item?.documentId,
              label: item?.title || "",
            };
          } else {
            return null;
          }
        })
        .filter((benefit) => benefit !== null)
    : [];
  return brandListData;
};

export const getSearchRoomData = (
  searchAvailableRoom: ConfigurationSearchFormQuery | null,
  params: { hotel_slug?: string },
) => {
  return searchAvailableRoom?.sharedDatasourcesReusableReservationTextDatasources.find(
    (item) =>
      params.hotel_slug
        ? item?.item_name === "Default Hotel Detail Reservation Datasource" ||
          item?.documentId === "79ed4ada324c9a9b6c71aedb"
        : item?.item_name === "Global" ||
          item?.documentId === "1d7f9e6d384e270f907ede4f",
  );
};
